/*eslint-disable */

import 'vue-datetime/dist/vue-datetime.css'

import { Datetime } from 'vue-datetime';
import Multiselect from 'vue-multiselect'
import { bus } from '@/main';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
// You need a specific loader for CSS files
export default {
  name: 'authorized-user-for-demo-request',
  components: {
    Multiselect,
    datetime: Datetime
  },
  props: [
    'meetingID'
  ],
  data () {
    return {
      live_demo_site:'',
      submitted:false,
      select_option:'company',
      minDatetime:new Date().toISOString(),
      slotTime:'',
      slotTimeList:null,
      slotTimeListArr:[],
      selectedTimeZone:'',
      selectedTimeSlot:'',
      selectedTimeSlotIndex:'',
      timeData:null,
      timeDataArr:[],
    }
  },
  computed: {
  },
  mounted () {
    this.$store.dispatch('getTimeSlotsWithZoneAction').then((res) => {
      this.slotTimeList = res.data
      // Convert the data into an array of objects
      if(!this.slotTimeList) return;
      this.slotTimeListArr = Object.entries(this.slotTimeList).map(([name, value]) => ({ name, value }));
    })
    this.$store.dispatch('getTimeSlotsforDemoAction').then((res) => {
      this.timeData = res.data.data
      if(this.timeData){
        // Convert the data into an array of objects
        this.timeDataArr = Object.entries(this.timeData).map(([time, timestamp]) => ({ time, timestamp }));
      }
    })
  },
  methods: {
    backToFirstScreenMethod(){
      bus.$emit('authorizedUserDemoForReqStateBus', false);
      document.body.classList.remove('body_right_scroll_remove')
    },
    handleSelect(selectedValue) {
      // Find the index of the selected item in the options array
      const index = this.selectedTimeZone.value.findIndex((option) => option === selectedValue);
      // Update the selectedIndex
      return index;
    },
    demoForRequestSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            title:'individual',
            date:this.live_demo_site,
            time:this.timeDataArr[this.handleSelect(this.selectedTimeSlot)].timestamp,
            timezone:this.selectedTimeZone.name,
            // timeslot:this.timeDataArr[this.selectedTimeSlot].time
            timeslot:this.selectedTimeSlot
          }
          this.$store.dispatch('userReqForDemoAction', data)
            .then((res) => {  
              this.backToFirstScreenMethod();
              toast.success(res.data.msg || 'Request processed successfully.');
              this.submitted =  false;
            }).catch((err) => {
              this.submitted =  false
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },
  },
  watch: {
  },
}